import { TEAM_FIELD } from '../type_name'
import {mapGetters} from "vuex";
const invalidValue = [ undefined, null, '']
export const headerHandler = header => {
    const header_clone = {...header}
    header_clone.align = header_clone.align || 'end'
    return header_clone
}
export default {
    name: TEAM_FIELD,
    props: {
        value: {
            type:[String, Number, Object]
        },
        header: {
            type:[String, Number, Object]
        }
    },
    computed: {
        ...mapGetters({
            teams_hash: 'async/root_teams_hash',
          }),
        valueHandle() {
            if (invalidValue.includes(this.value) && !invalidValue.includes(this.header.default_value)) {
                return this.header.default_value
            }
            const teams_hash = this.teams_hash || {}
            return teams_hash[this.value] && teams_hash[this.value].name
        }
    },
    render() {
        return <span>{this.valueHandle}</span> 
    }
}